export default __webpack_public_path__ + "static/media/sponsor-11.2f5c3bb2.svg";